import "jquery";
import * as ko from "knockout";
import {BaseCropComponent} from "./BaseCropComponent";
import {CleanedSeedsGroupedByCropNumber } from "../Models/Crops/CleanedSeedsGroupedByCropNumber";

export class CleanedSeeds extends BaseCropComponent<CleanedSeedsGroupedByCropNumber> {
    constructor() {
        super($('#cleanedseeds-table'));
    }
    init(): void {
        this.cropsApi.getCleanedSeeds().then((res) => {
            super.init(res, "cropNo", '*[data-bind="text: cleanedCrop.CropNumber"]');
        });
    }
}